/** PHP id → new path. Used for next.config redirects. */
export const productIdRedirects: Record<number, string> = {
  29: "/products/tile-stone-adhesive",
  30: "/products/stone-care-products",
  31: "/products/cleaners",
  33: "/products/waterproofing-construction-chemicals",
};

export const productDetailIdRedirects: Record<number, string> = {
  124: "/products/stone-care-products/stone-care-range",
  125: "/products/tile-stone-adhesive/adresh-307",
  126: "/products/tile-stone-adhesive/tile-adhesive-k60",
};

export const blogIdRedirects: Record<number, string> = {
  9: "/blog/best-stone-care-products",
  10: "/blog/best-waterproofing",
  11: "/blog/stone-adhesive",
};
